export default "__VITE_ASSET__DqMFBH0a__"